import { gql } from '@apollo/client';

import { subjectWithStatsFragment } from 'modules/subjects/graphql/fragments';

export const courseStatsFragment = gql`
  fragment CourseStats on CourseStats {
    id
    name
    subjects @type(name: "SubjectWithStats") {
      ...SubjectWithStats
    }
  }
  ${subjectWithStatsFragment}
`;
